import { PrinterOptionsSchema } from "@redotech/redo-fulfillment-group-common/printer";
import * as z from "zod";

export const printPickSessions = {
  name: "printPickSessions" as const,
  input: z.object({
    pickSessionIds: z.array(z.string()),
    printerId: z.number().optional(),
    printerOptions: PrinterOptionsSchema.optional(),
    idempotencyKey: z.string().optional(),
  }),
  output: z.object({ url: z.string() }),
};

export type PrintPickSessionsInput = z.infer<typeof printPickSessions.input>;
